import React, { ComponentType, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../slices/store";
import {
  clients,
  setLogout,
  login,
  checkAuthentication,
  getLoggedUser,
  signUp,
} from "../../slices/auth/authenticationSlice";
import {
  ChangePassword,
  ForgetPassword,
} from "../../slices/auth/api/authentication-api";
import { IUser } from "../user-management/models/User";
import { useNavigate } from "react-router-dom";
import { TodosContext } from "../../context";
import { useIdleTimer } from "react-idle-timer";
import updatePasswordModalData from "../../utils/helpers/helperDataset/updatePasswordModalData.json";
import { useMsal } from "@azure/msal-react";
import UseAuthConfig from "../../hooks/useAuthConfig";

export function withAuthenticationControllerWrapper<T>(
  Component: ComponentType<T>
) {
  return (hocProps: Omit<T, "userAuthentication">) => {
    const { alert, addAlert } = useContext(TodosContext);
    const { instance, inProgress } = useMsal();
    const dispatch = useDispatch<AppDispatch>();
    const { protectedResources }: any = UseAuthConfig();
    const [modalShow, setModalShow] = React.useState(false);
    const clientsData = useSelector(
      (state: RootState) => state.authentication.clients
    );
    const status = useSelector(
      (state: RootState) => state.authentication.status
    );
    const loggedUserData = useSelector(
      (state: RootState) => state.authentication.loggedUser
    );
    let loggedUser: any = "";
    loggedUser = window.localStorage.getItem("user");
    let bearerToken = `Bearer ${window.localStorage.getItem("token")}`;
    let navigate = useNavigate();

    let activeAccount: any;
    if (instance) {
      activeAccount = instance.getActiveAccount();
    }
    let userName = activeAccount?.name;
    let userRole = activeAccount?.idTokenClaims?.extension_ilpr;

    const handleLogout = () => {
      // dispatch(setLogout())
      instance.logoutRedirect();
    };

    useEffect(() => {
      let userParams = {
        username: loggedUser,
        token: bearerToken,
      };
      if (loggedUser) {
        dispatch(getLoggedUser(userParams));
      }
    }, [loggedUser]);

    const handleSignUp = (user: IUser) => {
      let userSignupParams = {
        user: user,
        url: protectedResources.apiTodoList.endpoint + `/accounts/signup`,
        accessToken: localStorage.getItem("AccessToken") || "",
      };
      dispatch(signUp(userSignupParams))
        .then((response: any) => {
          if (response.payload.status === 201) {
            addAlert(
              "Signup successfully, Please check your Email",
              "success",
              true
            );
            navigate("/login");
          } else {
            addAlert("Signup failed/User already exists", "failed", true);
          }
        })
        .catch((e) => {
          addAlert(e, "failed", true);
        });
    };

    const handleLogin = (loginData: any) => {
      dispatch(login(instance))
        .then((r: any) => {
          if (r.payload) {
            addAlert("Login successfully", "success", true);
          } else {
            addAlert(r.error.message, "failed", true);
          }
        })
        .catch((e) => {
          addAlert(e, "failed", true);
        });

      //popup
    };

    const handleForgetPassword = (email: string) => {
      ForgetPassword(email).then((r) => r);
    };

    const handleResetPassword = (oldPassword: string, newPassword: string) => {
      ChangePassword(loggedUser, oldPassword, newPassword, bearerToken)
        .then((r: any) => {
          if (r.status === 200) {
            addAlert("Password updated successfully", "success", true);
            setModalShow(true);
          } else {
            addAlert("Password updated failed.", "failed", true);
          }
        })
        .catch((e) => {
          addAlert(e, "failed", true);
        });
    };

    const onIdle = () => {
      handleLogout();
    };

    const idleTimer = useIdleTimer({
      onIdle,
      timeout: 1000 * 60 * 45,
    });

    const onHide = () => {
      setModalShow(false);
      dispatch(setLogout());
    };
    return (
      <Component
        {...(hocProps as T)}
        clientsData={clientsData}
        handleLogout={handleLogout}
        handleSignUp={handleSignUp}
        handleLogin={handleLogin}
        handleForgetPassword={handleForgetPassword}
        handleResetPassword={handleResetPassword}
        loggedUser={loggedUser}
        loggedUserData={loggedUserData}
        status={status}
        onHide={onHide}
        modalShow={modalShow}
        updatePasswordModalData={updatePasswordModalData}
        userName={userName}
        userRole={userRole}
        inProgress={inProgress}
      />
    );
  };
}
